<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...$$props}
  ><path
    fill="currentColor"
    fill-rule="evenodd"
    d="M11 20a9 9 0 1 0-9-9v9h9Zm0 1.5c5.8 0 10.5-4.701 10.5-10.5S16.8.5 11 .5C5.203.5.5 5.201.5 11v10.5H11Z"
    clip-rule="evenodd"
  /><path
    fill="currentColor"
    d="M5 12.5h6V14H5v-1.5Zm7.5 0H17V14h-4.5v-1.5ZM5 9.5h4.5V11H5V9.5Zm6 0h6V11h-6V9.5Z"
  /></svg
>
